import React, { useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import type { TeamMember } from "../../Booking-Form/typings/team-member";
import { colleagueDisplayName } from "../utils/dashboard2-schedule.utils";
import { DASHBOARD2_CHIP_AVATAR_SIZE_PX } from "../dashboard2.styles";

type Dashboard2ColleagueAvatarProps = {
  colleague: TeamMember;
};

export const Dashboard2ColleagueAvatar: React.FC<Dashboard2ColleagueAvatarProps> = ({
  colleague
}) => {
  const photoUrl = colleague.photoUrl?.trim() || undefined;
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [colleague.userId, photoUrl]);

  const showPhoto = Boolean(photoUrl) && !imageFailed;
  const initials = `${colleague.firstName?.charAt(0) ?? ""}${colleague.surname?.charAt(0) ?? ""}`;

  return (
    <Avatar
      src={showPhoto ? photoUrl : undefined}
      alt={colleagueDisplayName(colleague)}
      slotProps={{
        img: {
          onError: () => {
            setImageFailed(true);
          }
        }
      }}
      sx={theme => ({
        width: DASHBOARD2_CHIP_AVATAR_SIZE_PX,
        height: DASHBOARD2_CHIP_AVATAR_SIZE_PX,
        fontSize: "0.65rem",
        bgcolor: theme.palette.mode === "dark" ? "action.selected" : "grey.300",
        color: theme.palette.mode === "dark" ? "text.primary" : "text.secondary"
      })}
    >
      {initials}
    </Avatar>
  );
};
